import type { Bedrooms, HomeType } from '../types/funnel';

/** Ad parameters may preselect a size; the customer can always change it. */
export interface CreativeVariant {
  key: string;
  preset: { homeType?: HomeType; bedrooms?: Bedrooms };
}

export const creativeVariants: CreativeVariant[] = [
  { key: 'default', preset: {} },
  { key: '1br', preset: { homeType: 'apartment', bedrooms: '1' } },
  { key: '2br', preset: { bedrooms: '2' } },
  { key: '3br', preset: { bedrooms: '3' } },
  { key: '4br', preset: { homeType: 'house', bedrooms: '4' } },
  { key: '5br', preset: { homeType: 'house', bedrooms: '5' } },
  { key: 'few_items', preset: { bedrooms: 'few' } },
];

export function findVariant(key: string): CreativeVariant {
  return creativeVariants.find((v) => v.key === key) ?? creativeVariants[0];
}
